import { enqueueSnackbar } from 'notistack';

import { getErrorMessage } from './getErrorMessage';

export const showErrorAlert = (error: unknown) => {
  enqueueSnackbar(getErrorMessage(error));
};
